import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { StaffrecruitmentComponent } from './staffrecruitment/staffrecruitment.component';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { IneterviewcallComponent } from './ineterviewcall/ineterviewcall.component';
import { ScoreentryComponent } from './scoreentry/scoreentry.component';
import { StaffrecruitmentonlineComponent } from './staffrecruitmentonline/staffrecruitmentonline.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { PaymentGuard } from './payment.guard';
import { NewAdminPanelComponent } from './new-admin-panel/new-admin-panel.component';


export const routes: Routes = [
	{ path: '', component: LoginComponent },
    { path: 'staff-recruitment', component: StaffrecruitmentComponent,canActivate: [AuthGuard]},
    { path: 'admin-staff-recruitment', component: NewAdminPanelComponent,canActivate: [AuthGuard]},
	{ path: 'interview-call', component: IneterviewcallComponent,canActivate: [AuthGuard]},
    { path: 'score-entry', component: ScoreentryComponent, canActivate: [AuthGuard]},
    { path: 'recruitment-form', component: StaffrecruitmentonlineComponent},
    { path: 'getpayment/:msg/:id', component: PaymentDetailsComponent, canActivate: [PaymentGuard]},
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes);

//{ path: 'staff-recruitment',component: StaffrecruitmentComponent, pathMatch: 'full', canActivate: [AuthGuard] }



// WEBPACK FOOTER //
// ./src/app/app.routes.ts